<template>
  <div class="test_group_warp">
    <div class="left">
      <LeftController @initList="initData" />
    </div>
    <div class="right">
      <TopCard ref="TopCardRef"
               :text="titleText"
               :showBack="false" />

      <div v-if="tableData.length==0"
            class="noData">
        <img src="@/assets/course/noData.png"
              alt="">
        <div class="text">暂无资源</div>
      </div>
      <div class="list" v-else>

        <div class="warp">

          <div style="margin: 16rem 0;display: flex;justify-content: space-between;align-items: center;">
            <div>
              <el-button style="margin-right: 16rem;border-radius: 100rem;font-size: 20rem;line-height: 30rem;color: #2196f3;border-color: #2196f3;padding: 7rem 24rem;"
                            @click="handleSelectAllChange">{{isAllChecked ? "取消全选" : "全选"}}</el-button>
              <el-button style="margin-right: 16rem;border-radius: 100rem;font-size: 20rem;line-height: 30rem;color: #2196f3;border-color: #2196f3;padding: 7rem 24rem;"
                      @click="delPaper">删除</el-button>
            </div>

            <div class="keyword">
              <el-input style="font-size: 20rem;line-height: 30rem;color: #2196f3;" placeholder="搜索内容" v-model="keywords">
                <i slot="append" class="el-icon-search" @click='search'></i>
              </el-input>
            </div>
          </div>

          <div v-for="(row,index) in tableData"
               :key="index"
               class="paper_list">
            <div>
              <el-checkbox :checked="row.isCheck" v-model="row.isCheck"
                          style="width: 24rem;height: 24rem;"
                          @change="handleCheckChange(row.isCheck,row.user_paper_id)"></el-checkbox>
            </div>
            <div class="paper_img">
              <div style="font-size: 20rem;font-weight:400;line-height:30rem;color: #999;">
                <!-- 总分：{{row.paper_score}} -->
                {{row.paper_time}}
              </div>
              <div class="img"><img src="@/assets/choiceness/mypaper.png"
                     alt=""></div>
            </div>
            <div class="paper_title">
              <div style="display: flex;gap: 16rem;flex-wrap: wrap;">
                <span v-if="row.template_name != null && row.template_name.length != 0"
                      style="font-size: 24rem;font-weight: 600;line-height: 36rem;color: #2196f3;border-radius: 8rem;border: 1rem solid #2196f3;padding: 4rem 8rem;">
                  {{row.template_name}}
                </span>
                <span style="font-size: 24rem;font-weight: 600;line-height: 36rem;color: #666;border-radius: 8rem;border: 1rem solid #666;padding: 4rem 8rem;">
                  <!-- {{row.correct_type == 1 ? '教师批改试卷' : '自评试卷'}} -->
                   {{row.correct_type == 2 ? '自评试卷':'教师批改试卷'   }}
                </span>
              </div>
              <div>
                <span class="overflow-hidden"
                      style="font-size: 28rem;font-weight: 600;line-height: 42rem;">{{row.paper_desc?row.paper_desc:'无'}}</span>
              </div>
              <div style="font-size: 24rem;font-weight: 400;line-height: 36rem;color: #999;">
                <span>试卷ID:</span>
                <span>{{row.user_paper_id}}</span>
              </div>
              <!-- <div class="comment">
                    <span>
                      试卷总评:</span>
                    <span>
                      {{row.paper_comment?row.paper_comment:'无'}}
                    </span>
                  </div> -->
            </div>
            <div class="paper_score">
              <div v-if="correctFinishedCanShow(row)"
                   style="display: flex;gap: 32rem;">
                <!-- <div><span>排名：</span><span style="color:#FB9930">{{row.rank}}</span></div> -->
                <div v-if="parseFloat(row.user_score) != 0"><span style="color: #666;">打败了{{row.percent}}%人</span></div>
              </div>
              <div><span>我的得分：</span><span style="color:#F2413A;font-weight:600;">{{Number(row.user_score) == '-1' ? '-' : row.user_score}}</span></div>
              <div><span>总分：</span><span style="color:#333;font-weight:600;">{{row.paper_score}}</span></div>
              <div v-if="correctFinishedCanShow(row)"><span>平均得分：</span><span style="color:#333;font-weight:600;">{{row.avg_score}}</span></div>
              <div style="display: flex;flex-wrap: wrap;align-self: stretch;">
                <span style="color: #999;">总评：</span>
                <span class="overflow-hidden"
                      style="flex: 1 0 0;color:#333">
                  <label v-if="row.paper_comment && row.paper_comment.length > 18"
                         @click="showCommentDetail(row)"
                         style="color: #2196f3; float: right;clear: both;line-height: 36rem;cursor: pointer;">查看全部</label>
                  {{row.paper_comment?row.paper_comment:'-'}}
                </span>
              </div>
            </div>
            <!-- <div :class="{'desc':true,'check':row.correct_type == 2 && selfCorrectStatus.indexOf(row.judge_status) != -1}">
                {{getValue(row)}}
              </div> -->
            <div :class="correctFinished.indexOf(row.judge_status) != -1 ? 'correct-info' : 'correct-info'">
              <span>{{getValue(row)}}</span>
            </div>
            <div>
              <div class="btn_warp">
                <div class="btn"
                     @click="doPaper(row)">
                  继续做卷
                </div>
                
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftController from '@/views/components/left_controller.vue'
import TopCard from '@/views/components/top_card/index.vue'
import { getNnotPress, delPaper } from '@/api/my_paper.js'

export default {
  data () {
    return {
      tableData: [],
      subject_id: null,
      moduleList: {
        1: '组卷测试',
        // 2: '考点组卷',
        3: '整卷测试',
        4: '考点训练',
        5: '章节测试'
      },
      selfCorrectStatus: [101, 1, 102, 2, 103, 3, 10, 7, 107],
      correctFinished: [4, 104, 105, 106],
      titleText: '',
      isAllChecked: false,
      keywords: '',
      paper_ids: [],
      exclude_ids: [],
    }
  },
  components: {
    LeftController, TopCard
  },
  mounted () {
    this.$removePaperInfo()
    let userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    if (userInfo.edu_grade_id == 1) {
      this.titleText = "备考进度"
    } else {
      this.titleText = "学习进度"
    }
  },
  methods: {
    async initData (id) {
      this.subject_id = id
      let params = {
        subject_id: id,
        status: 0
      }
      const { data } = await getNnotPress(params)
      this.tableData = data.volist
      this.tableData.map(item => {
        this.$set(item, 'isCheck', false)
      })
    },
    search() {
      console.log("search")
    },
    doPaper (item) {
      this.$router.push('/doPaper?type=2&form=' + JSON.stringify({ user_paper_id: item.user_paper_id }))
    },
    delPaper () {
      if (this.paper_ids.length === 0) {
        this.$message.warning('请选择试卷')
        return
      }
      this.$confirm("确定删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let params = {
          user_paper_id: this.isAllChecked ? '' : this.paper_ids.join(','),
          is_all_select: this.isAllChecked?1:0,
          subject_id: this.subject_id,
          exclude_ids: this.isAllChecked ? this.exclude_ids.join(',') : '',
        }
        await delPaper(params)
        this.$message.success('删除成功')
        this.page = 1
        this.initData(this.subject_id)
      }).catch(() => { })
    },
    handleCheckChange (isCheck, id) {
      if (isCheck) {
        this.paper_ids.push(id)
      } else {
        this.paper_ids = this.paper_ids.filter(item => item !== id)
      }

      if (this.isAllChecked) {
        if (isCheck) {
          this.exclude_ids = this.exclude_ids.filter(item => item !== id)
        } else {
          this.exclude_ids.push(id)
        }
      }
    },
    handleSelectAllChange () {
      this.isAllChecked = !this.isAllChecked
      this.tableData.forEach(row => {
        row.isCheck = this.isAllChecked;
        this.paper_ids = this.isAllChecked ? this.tableData.map(item => item.user_paper_id) : []
      });
      if (!this.isAllChecked) {
        this.exclude_ids = []
        this.paper_ids = []
      }
    },

    getValue (row) {
      var valus = {
        101: '选择题系统自动批改，非选择题未批改',
        1: '选择题系统自动批改，非选择题未批改',
        102: '系统自动批改，大题学生部分批改',
        103: '学生部分批改（全大题，批改部分）',
        104: '学生完成批改（全大题，全部批改完成）',
        4: '全部批改完成（选择题+ 大题）',
        105: '系统自动批改完成（全选择题）',
        106: '全部批改完成（选择题+ 大题）',
        107: '大题全部未批改',
        16: '试卷批改中',
        0: '试卷未完成'
      }
      return valus[row.judge_status]
    },
    correctFinishedCanShow (row) {
      return (this.correctFinished.indexOf(row.judge_status) != -1 && row.famous_paper_source != 0)
    },
  }
}
</script>

<style lang="scss" scoped>
.test_group_warp {
  overflow: hidden;
  display: flex;
  .left {
    width: 100rem;
  }
  .right {
    width: calc(100% - 100rem);
    background: #f6f6f6;
    .tabs {
      margin-top: 22rem;
      display: flex;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 18rem;
      .tab {
        cursor: pointer;
        width: 260rem;
        height: 54rem;
        background: #2196f3;
        border-radius: 30rem;
        color: #ffffff;
        font-size: 24rem;
        font-weight: 800;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .noData {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 80%;
      img {
        width: 200rem;
        height: 200rem;
      }
      .text {
        color: var(--light-999999, #999);
        font-size: 24rem;
        line-height: 36rem;
        font-style: normal;
        font-weight: 400;
      }
    }
    .list {
      padding: 0 40rem;
      max-height: calc(100vh - 60rem - 40rem);
      -ms-overflow-style: none;
      background: white;
      overflow-y: auto;
      overflow: -moz-scrollbars-none;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      .div {
        padding: 10rem;
        border-bottom: 1rem solid #f1f1f1;
        display: flex;
        align-items: center;
        &:hover {
          background: rgba($color: #2196f3, $alpha: 0.1);
        }
      }
      // div {
      //   height: 80rem;
      //   line-height: 80rem;
      // }
      .paper_name {
        margin-left: 50rem;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        // height: 110rem;
        padding: 10rem;
        .text {
          min-height: 70rem;
          margin-left: 20rem;
          div {
            width: 700rem;
            &:nth-child(1) {
              font-size: 20rem;
              font-weight: bold;
              color: #000000;
            }
            &:nth-child(2) {
              margin-top: 10rem;
              font-size: 20rem;
              font-weight: bold;
              color: #000000;
              // line-height: 20rem;
            }
            &:nth-child(3) {
              margin-top: 10rem;
              font-weight: 500;
              font-size: 20rem;
              color: #333333;
              display: flex;
              flex-wrap: wrap;
              word-wrap: break-word;
              span {
                &:nth-child(1) {
                  width: 100rem;
                }
                &:nth-child(2) {
                  width: calc(100% - 200rem);
                }
              }
            }
            &:nth-child(4) {
              margin-top: 10rem;
              font-weight: 500;
              font-size: 20rem;
              color: #333333;
              display: flex;
              flex-wrap: wrap;
              word-wrap: break-word;
              span {
                &:nth-child(1) {
                  width: 100rem;
                }
                &:nth-child(2) {
                  width: calc(100% - 200rem);
                }
              }
            }
          }
        }
      }
      .score {
        font-weight: 500;
        color: #333333;
        font-size: 20rem;
        // height: 110rem;
        display: flex;
        align-items: center;
        margin-left: 30rem;
      }
      .btn_warp {
        display: flex;
        // height: 110rem;
        align-items: center;
        justify-content: flex-end;
        .btn {
          margin-right: 20rem;
          width: 120rem;
          height: 44rem;
          background: #2196f3;
          border-radius: 5rem;
          font-size: 20rem;
          font-weight: bold;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }
    }
  }
}

.paper_list {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
  padding: 24rem 40rem;
  max-height: 296rem;
  border-bottom: 1rem solid #eee;
  gap: 40rem;
   &:hover {
          background: rgba($color: #2196f3, $alpha: 0.1);
        }
  .paper_img {
    display: flex;
    gap: 8rem;
    flex-direction: column;
    .img {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 240rem;
      height: 160rem;
      background: #6cb9f5;
      border-radius: 16rem;
      flex-shrink: 0;
      img {
        width: 48rem;
        height: 48rem;
      }
    }
  }
  .paper_title {
    width: 468rem;
    display: flex;
    gap: 8rem;
    flex-direction: column;
  }
  .paper_score {
    width: 400rem;
    display: flex;
    gap: 8rem;
    flex-direction: column;
    font-size: 24rem;
    font-weight: 400;
    line-height: 36rem;
    color: #999;
  }
  .correct-danger {
    width: 320rem;
    border-radius: 16rem;
    padding: 8rem 16rem;
    background-color: rgba(244, 65, 58, 0.1);
    span {
      font-size: 28rem;
      font-weight: 400;
      line-height: 42rem;
      color: #f2413a;
    }
  }
  .correct-info {
    width: 320rem;
    border-radius: 16rem;
    padding: 8rem 16rem;
    // background-color: rgba(51, 51, 51, 0.1);
    background-color: #f5f5f5;
    span {
      font-size: 28rem;
      font-weight: 400;
      line-height: 42rem;
      color: #333;
    }
  }
  .paper_btn {
    cursor: pointer;
    width: 96rem;
    border-radius: 8rem;
    padding: 8rem 28rem;
    font-size: 24rem;
    font-weight: 400;
    line-height: 36rem;
    align-items: center;
    color: #fff;
  }
}
.keyword {
  display: inline-block;
  border: solid 1px #cccccc;
  background: #fff;
  overflow: hidden;
  border-radius: 30rem;
  ::v-deep .el-input--medium .el-input__inner {
    height: 48rem;
    line-height: 48rem;
    // border-radius: 30rem;
    border: 0;
  }
  ::v-deep .el-input-group__append,
  .el-input-group__prepend {
    background-color: #fff;
    border: 0;
    padding: 0 20rem;
    width: 1px;
    white-space: nowrap;
    cursor: pointer;
  }
  .el-input--medium {
    font-size: 20rem;
  }
}
.overflow-hidden {
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
}
.overflow-hidden::before {
  float: right;
  content: "";
  background-color: red;
  /* 减去尾随按钮高度  */
  height: calc(100% - 36rem);
}

::v-deep .el-checkbox__inner {
    display: inline-block;
    position: relative;
    border: 1px solid #DCDFE6;
    border-radius: 2px;
    box-sizing: border-box;
    width: 32rem;
    height: 32rem;
    background-color: #FFF;
    z-index: 1;
    transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46), background-color .25s cubic-bezier(.71,-.46,.29,1.46);
}
::v-deep .el-checkbox__inner::after {
  box-sizing: content-box;
  content: "";
  border: 1px solid #FFF;
  border-left: 0;
  border-top: 0;
  height: 20rem;
  left: 10rem;
  position: absolute;
  top: 2rem;
  transform: rotate(45deg) scaleY(0);
  width: 9rem;
  transition: transform .15s ease-in .05s;
  transform-origin: center;
}
</style>